import { AtomizedForm, atomField, required } from 'atoms/form-atoms';
import { atom } from 'jotai';

export interface CreateCrmAccountRequest {
  accountName: string;
  type: string;
  phoneNumber: string;
  accountSource: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
}

export const createCrmAccountFormAtom = atom<
  AtomizedForm<CreateCrmAccountRequest>
>({
  accountName: atomField<string>('', { validate: required }),
  type: atomField<string>('', { validate: required }),
  phoneNumber: atomField<string>(''),
  accountSource: atomField<string>('', { validate: required }),
  address: atomField<string>(''),
  city: atomField<string>(''),
  state: atomField<string>(''),
  zipCode: atomField<string>(''),
});

export const resetCreateCrmAccountFormAtom = atom<null, [], void>(
  () => null,
  (get, set) => {
    const form = get(createCrmAccountFormAtom);
    set(form.accountName, { value: '', __options: { skipDirtyCheck: true } });
    set(form.type, { value: '', __options: { skipDirtyCheck: true } });
    set(form.phoneNumber, { value: '', __options: { skipDirtyCheck: true } });
    set(form.accountSource, {
      value: '',
      __options: { skipDirtyCheck: true },
    });
    set(form.address, { value: '', __options: { skipDirtyCheck: true } });
    set(form.city, { value: '', __options: { skipDirtyCheck: true } });
    set(form.state, { value: '', __options: { skipDirtyCheck: true } });
    set(form.zipCode, { value: '', __options: { skipDirtyCheck: true } });
  }
);
